import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
	title: {
		color: "#474747",
		//fontSize: "4vh",
		lineHeight: "0.9",
		letterSpacing: "-0.66px",
		margin: "-1% 0 -5% 0",
		fontSize: "20px"
	},
	titleText: {
		color: "#474747",
		//fontSize: "4vh",
		lineHeight: "0.9",
		//letterSpacing: "-0.66px",
		margin: "2% 3% -7%",
	},
	select: {
		width: "30%",
		backgroundColor: "rgba(0, 0, 0, 0.12)",
		color: "#8f8e8e",
		borderBottom: "none",
	},
	selectInput: {
		padding: "10.5px 3px !important",
	},
	root: {
		backgroundColor: "#440067",
		color: "#ffffff",
		height: 44,
		width: 335,
		fontSize: 12,
		fontWeight: "normal",
		textTransform: "none",
		borderRadius: 20,
	},
	subtitle: {
		color: "#393762",
		fontSize: 16,
	},
	field: { width: "95%", paddingBottom: "5%" },
	icon: {
		cursor: "pointer",
		color: "#474747",
	},
	message: {
		color: "#939393c2",
		fontSize: "80%",
		paddingBottom: 10,
	},
	divMessage: {
		width: "65%",
		display: "flex",
		textAlign: "center",
		justifyContent: "center",
	},
	button: {
		backgroundColor:"rgb(69 0 103)",
		cursor: "unset",
		padding: "7px",
		color:"#fff",
		height: 44,
		fontSize: "15px",
		//display: "flex",
		flex: 1,
		width: "100%",
		maxWidth: "400px",
		borderRadius: "25.5px"
	},
	buttonAlterar: {
		backgroundColor: "transparent",
		color: "#3689ea",
		height: 18,
		fontSize: 14,
		fontWeight: "bold",
		textTransform: "none",
		paddingBottom: 10,
	},
	termos: {
		color: "#3689ea",
	},
	email: {
		fontWeight: "normal",
		textTransform: "none",
	},
	whatsApp: {
		borderWidth: 2, 
		borderColor: "#3689ea",
		backgroundColor: "transparent",
		color: "#3689ea",
		width: "300px",
		borderRadius: "25px",
	},
	sms: {
		backgroundColor: "#DCDCDC",
		color: "#ffffff",
		width: "300px",
		borderColor: "#D3D3D3",
	}
}));
